import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const widthOfMasterDetailMenu = 250;

let baseStyles = {
    container: {
        marginTop: -15,
        marginBottom: 50
    },
    sectionHeader: {
        marginTop: 0
    },
    headerTitle: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    headerTitleText: {
        color: Theme.primaryTextColor,
        paddingLeft: widthOfMasterDetailMenu,
        fontSize: 18,
        fontFamily: Theme.ultraFont,
        fontWeight: '900'
    },
    favoriteHeaderTitle: {
        margin: 10,
        color: Theme.primaryTextColor,
        marginLeft: widthOfMasterDetailMenu
    },
    headerLeft: {
        height: '100%',
        width: widthOfMasterDetailMenu,
        borderRightColor: '#4e5758',
        borderRightWidth: 0.5,
        justifyContent: 'center'
    },
    background: {
        flex: 1,
        borderTopWidth: 0.5,
        borderTopColor: Theme.secondaryTextColor
    },
    wrapper: {
        width: widthOfMasterDetailMenu,
        borderRightWidth: 0.5,
        borderRightColor: '#4e5758',
        height: '100%'
    },
    sectionList: {
        paddingLeft: 20,
        marginTop: Device.isWeb ? 2 : 2
    },
    sectionItem: {
        paddingVertical: 15,
        paddingLeft: 12,
        backgroundColor: 'transparent'
    },
    sectionItemSelected: {
        backgroundColor: '#6C6C6C'
    },
    sectionItemText: {
        color: Theme.primaryTextColor,
        fontSize: Device.isTabletOrWeb ? 16 : 15
    },
    sectionHeaderTablet: {
        marginBottom: 0
    },
    sectionHeaderText: {},
    contentContainer: {
        flex: 1
    },
    contentDetail: {
        flex: 3
    },
    noHeaderPadding: { paddingTop: 20 }
};

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        headerLeft: {
            height: '100%',
            width: widthOfMasterDetailMenu,
            justifyContent: 'center'
        }
    };
}

export default StyleSheet.create(baseStyles);
